import React from 'react';
import functions from '../../utils/functions';
import { s } from '../../Style.jsx';

const Collapsed = ({ order, setViewingOrder, vendors, drivers }) => {

    const status = () => {
        if (!order?.driver) return { border: 0, color: "red", title: '', icon: '' };
        if (order?.dispatch_status === 'complete') return { border: 10, color: "gray", title: 'Complete', icon: 'fas fa-truck' };
        if (order?.driver_status === 'clear') return { border: 0, color: "#ccc", title: 'Clear', icon: '' };
        if (order?.driver_status === 'leaving') return { border: 10, color: "green", title: 'Leaving', icon: 'fas fa-check' };
        if (order?.driver_status === 'copy') return { border: 10, color: "green", title: 'Copy', icon: 'fas fa-truck' };
        return { border: 10, color: "orange", title: '', icon: 'fas fa-exclamation' };
    }

    return <>
        <td style={{ flex: .2, opacity: order?.dispatch_status === 'complete' ? 0.5 : 1 }}>
            <s.IconButton icon="fas fa-edit" does={() => setViewingOrder(order)} /></td>

        <td style={{ ...s.tableCell, flex: .5, opacity: order?.dispatch_status === 'complete' ? 0.5 : 1 }}>
            {order.id}</td>

        <td style={{ ...s.tableCell, flex: 1, opacity: order?.dispatch_status === 'complete' ? 0.5 : 1 }}>
            {vendors.find(v => v.id === order.vendorId) ? <>
                <span style={{ fontSize: 14, fontWeight: "bold", color: "#333", textTransform: "capitalize", display: "block" }}>{vendors.find(v => v.id === order.vendorId)?.name}</span>
                <span style={{ fontSize: 12, color: "#888", textTransform: "capitalize", display: "block" }}>{vendors.find(v => v.id === order.vendorId)?.address}</span>
            </> : order.pickup || ""}
        </td>

        <td style={{ ...s.tableCell, flex: 1, opacity: order?.dispatch_status === 'complete' ? 0.5 : 1 }}>
            {order.address?.split(',')[0]}</td>

        <td style={{ ...s.tableCell, flex: 1, opacity: order?.dispatch_status === 'complete' ? 0.5 : 1 }}>
            {drivers.find(d => d.id === order.driver)?.name || ''}</td>

        <td style={{ ...s.tableCell, flex: 1, opacity: order?.dispatch_status === 'complete' ? 0.5 : 1, display: "flex", flexDirection: "row", gap: 5, alignItems: "center" }}>
            <s.IconButton size={14} icon={status().icon} does={() => {}} textColor={status().color} color="transparent" />
            <span>{status().title || "..."}</span>
        </td>
    </>;


}
export default Collapsed;
